import { c as _c } from "react/compiler-runtime";
import { format, formatDistanceToNow } from 'date-fns';
import capitalize from 'lodash/capitalize';
type DateRowProps = {
  label: string;
  date: string;
  variant?: 'absolute' | 'relative';
};
const DateRow = t0 => {
  const $ = _c(11);
  const {
    label,
    date,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "absolute" : t1;
  let t2;
  if ($[0] !== date || $[1] !== variant) {
    t2 = () => {
      if (variant === "absolute") {
        return <p className="text-snippet-2 text-primary">{format(new Date(date), "HH:mm, MM/dd/yy")}</p>;
      }
      return <p className="text-snippet-2 text-secondary">{capitalize(formatDistanceToNow(new Date(date), {
          addSuffix: true
        }))}</p>;
    };
    $[0] = date;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getDate = t2;
  let t3;
  if ($[3] !== label) {
    t3 = <p className="text-body-2 text-tertiary">{label}</p>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== date || $[6] !== getDate) {
    t4 = date ? getDate() : "-";
    $[5] = date;
    $[6] = getDate;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex items-center justify-between">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default DateRow;